'use strict';

module.exports = function (goldApi, authenticationModel) {
	const self = this;
	self.generateExportConfiguration = function (format) {
		return authenticationModel.getLicense()
		.then((license) => goldApi.exec('file/export_config', {'license': license, 'format': format}));
	};
	self.generateImportConfiguration = function (mimeType) {
		return goldApi.exec('file/import_config', {'mimeType': mimeType});
	};
	self.generateImportMapConfiguration = function (convertFromType) {
		return authenticationModel.getLicense()
		.then((license) => goldApi.exec('file/import_map/upload_config', {'license': license, 'convertFromType': convertFromType}));
	};

};
